import React from 'react'
import { Link } from 'react-router-dom';
import teamData from "../data/teamData.json";
import img1 from "../assets/images/team/team-mem-img1.png";

export const teamImageMap = {
    "team-mem-img1.png": img1,
} as const;

export interface TeamMember {
    id: number;
    name: string;
    role: string;
    image: keyof typeof teamImageMap;
}

type TeamSectionProps = {
    limit?: number;
};

const TeamSection: React.FC<TeamSectionProps> = ({ limit }) => {
    const slicedData = limit
        ? (teamData as TeamMember[]).slice(0, limit)
        : (teamData as TeamMember[]);
    return (
        <>
            <div className="row exper-team-row-home justify-content-center">
                {slicedData.map((team) => (
                    <div
                        className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6"
                        key={team.id}
                    >
                        <div className="team-circle-link zoom_in">
                            <div className="team-circle-main">
                                <Link to="/TeamDetails" className="inner-team-circle">
                                    <img
                                        src={teamImageMap[team.image]}
                                        alt={team.name}
                                    />
                                </Link>
                            </div>
                            <h3>{team.name}</h3>
                            <p>{team.role}</p>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default TeamSection
